import axios from "axios";
import { ShipDataType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";

export const cloneUserShipApi = async (
  shipId: string,
): Promise<ShipDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");
  const response = await axios.post<ShipDataType>(
    `${API_BASE_URL}/clone-ship/${shipId}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
